import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const apiModule = api.users
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: 'desc',
      showOrder: true
    },
    phone: {
      data: 'phone',
      title: 'Телефон',
      value: null,
      type: 'phone',
      order: null,
      showOrder: false
    },
    repost: {
      data: 'repost',
      title: 'Репосты',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    bonus: {
      data: 'bonus',
      title: 'Бонусы',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    sale: {
      data: 'sale',
      title: 'Скидка',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    bonusDate: {
      data: 'bonusDate',
      title: 'Дата начисления бонусов',
      value: null,
      type: 'date',
      order: null,
      showOrder: true
    },
    group: {
      data: 'group',
      title: 'Группа',
      value: null,
      type: null,
      handler: function (data) {
        let group = data.group
        if (!group) return 'нет'
        return group.name
      }
    },
    ordersCount: {
      data: 'ordersCount',
      title: 'Количество заказов',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    ordersBonus: {
      data: 'ordersBonus',
      title: 'Бонусов потрачено, бал.',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    ordersPrice: {
      data: 'ordersPrice',
      title: 'Сумма заказов, руб.',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    userEvents: {
      data: 'userEvents',
      title: 'Участие',
      value: null,
      type: 'checkbox',
      order: null,
      showOrder: true,
      handler: function (data) {
        if (data.userEvents && data.userEvents.length > 0) return true
        else return false
      }
    },
    userGroup: {
      data: 'group',
      title: 'Участие',
      value: null,
      type: 'checkbox',
      order: null,
      showOrder: true,
      handler: function (data) {
        if (data.group) return true
        else return false
      }
    }
  }
}

function role () {
  return localStorage.getItem('role')
}

const state = {
  model: getModel(),
  id: null,
  show: 'users',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {},
  tabs: {
    user: {
      data: 'user',
      title: 'Пользователь',
      active: true
    },
    orders: {
      data: 'orders',
      title: 'Заказы',
      active: false
    },
    questions: {
      data: 'questions',
      title: 'Опрос',
      active: false
    }
  },
  filters: {
    bonus: [],
    repost: [],
    sale: [],
    ordersBonus: [],
    ordersPrice: [],
    ordersCount: [],
    phones: [],
    groups: []
  },
  filtersQuery: {},
  showFilters: false,
  isFilter: false,
  find: [],
  finded: null
}
const getters = {
  getModel (state) {
    return state.model
  },
  getId (state) {
    return state.id
  },
  getShow (state) {
    return state.show
  },
  getOne (state) {
    return state.question
  },
  getAll (state) {
    return state.questions
  },
  getErrors (state) {
    return state.errors
  },
  getErrMain (state) {
    return state.errMain
  },
  getNavs (state) {
    return state.navs
  },
  getTabs (state) {
    return state.tabs
  },
  getFilters (state) {
    return state.filters
  },
  getFiltersQuery (state) {
    return state.filtersQuery
  },
  getShowFilters (state) {
    return state.showFilters
  },
  getIsFilter (state) {
    return state.isFilter
  },
  getFind (state) {
    return state.find
  },
  getFinded (state) {
    return state.finded
  }
}
const mutations = {
  setModel (state, data) {
    state.model = data
  },
  setId (state, data) {
    state.id = data
  },
  setShow (state, data) {
    state.show = data
  },
  setOne (state, data) {
    state.question = data
  },
  setAll (state, data) {
    state.questions = data
  },
  setErrors (state, data) {
    state.errors[data.param] = data.value
  },
  setErrMain (state, data) {
    state.errMain = data
  },
  setTab (state, data) {
    state.tabs[data.param].active = data.value
  },
  setOrder (state, data) {
    if (data.param === 'group' && !state.model[data.param]) {
      data.param = 'userGroup'
    }
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    }
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order === 'desc') order = 'asc'
    else if (order === 'asc') order = null
    state.model[data.param].order = order
  },
  setFilters (state, data) {
    state.filters = data
  },
  setFiltersQuery (state, data) {
    state.filtersQuery = data
  },
  resetFiltersQuery (state) {
    state.filtersQuery = {}
  },
  setShowFilters (state, data) {
    state.showFilters = data
  },
  setIsFilter (state, data) {
    state.isFilter = data
  },
  setFind (state, data) {
    state.find = data
  },
  setFinded (state, data) {
    state.finded = data
  }
}
const actions = {
  setActiveTab ({ commit, state }, data) {
    let param = data.param
    let tabs = state.tabs
    for (let tab in tabs) {
      if (param === tab) commit('setTab', { param: tab, value: true })
      else commit('setTab', { param: tab, value: false })
    }
  },
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    if (errors) {
      for (let err in errors) {
        commit('setErrors', { param: err, value: null })
      }
    }
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'user')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'user')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'users')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      let id
      if (data && data.params && data.params.id) id = data.params.id
      else id = state.id
      if (id) {
        let result = await httpService.get(apiModule[role()].getOne, { id: id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      }
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      }
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAll, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async getFilters ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(apiModule[role()].getFilters, data.params)
      commit('setFilters', result.data)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async giveBonus ({ state, commit, dispatch }, data) {
    try {
      await httpService.post(apiModule[role()].giveBonus, data)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async runFind ({ state, commit, dispatch }, data) {
    try {
      commit('setFinded', null)
      let result = await httpService.get(apiModule[role()].getAll, data.params)
      if (!result && !result.data && !result.data.data) commit('setFind', [])
      let items = result.data.data
      let find = []
      items.forEach(item => {
        find.push(item.phone)
      })
      commit('setFind', find)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
